module.exports = __webpack_public_path__ + "img/Paimnet2.3964515c.png";